import React from 'react';

// HoC
import { withStyles } from '@material-ui/core/styles';
// Components
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
  root: {
    paddingLeft: 5,
  },
  checkBox: {
    padding: 4,
  },
  infoIcon: {
    height: '.9em',
    width: '.9em',
  },
});

const CrewMember = ({
  firstName,
  lastName,
  email,
  selected,
  onClick,
  classes = {},
}) => (
  <Tooltip title={email} enterDelay={500}>
    <ListItem
      key={`${firstName}-${lastName}`}
      role={undefined}
      button
      onClick={onClick}
      className={classes.root}
      data-test-id={`CrewMember-listItem-${firstName}-${lastName}`}
    >
      <Checkbox checked={selected} className={classes.checkBox} />
      <ListItemText primary={`${lastName}, ${firstName}`} />
    </ListItem>
  </Tooltip>
);

export default withStyles(styles)(CrewMember);
